import { createTheme, type CSSVariablesResolver } from '@mantine/core';

import { modalTheme } from '@shared/ui/modal/theme';

import classes from './theme.module.css';

export const theme = createTheme({
  fontFamily: 'var(--font-family-ui)',
  headings: { fontFamily: 'var(--font-family-display)', fontWeight: '700' },
  primaryColor: 'brand',
  primaryShade: { light: 7, dark: 3 },
  autoContrast: true,
  defaultRadius: 'md',
  components: {
    Button: {
      classNames: { root: classes.buttonRoot },
    },
    ActionIcon: {
      classNames: { root: classes.actionIconRoot },
    },
    Checkbox: {
      defaultProps: {
        color: 'var(--color-action-strong)',
        iconColor: 'var(--color-on-action-strong)',
      },
    },
    Input: {
      classNames: {
        wrapper: classes.inputWrapper,
        input: classes.input,
        section: classes.inputSection,
      },
    },
    Loader: {
      defaultProps: { type: 'oval', color: 'var(--color-brand)' },
      classNames: { root: classes.loaderRoot },
    },
    Modal: modalTheme,
    PasswordInput: {
      classNames: {
        input: classes.passwordInput,
      },
    },
    Textarea: {
      classNames: {
        input: classes.textarea,
      },
    },
  },
  colors: {
    brand: [
      '#edf5ff', // ds-allow-hardcode: Mantine palette adapter
      '#dcecff', // ds-allow-hardcode: Mantine palette adapter
      '#c3dfff', // ds-allow-hardcode: Mantine palette adapter
      '#9bc5f9', // ds-allow-hardcode: Mantine palette adapter
      '#7eafea', // ds-allow-hardcode: Mantine palette adapter
      '#6094d8', // ds-allow-hardcode: Mantine palette adapter
      '#3979c7', // ds-allow-hardcode: Mantine palette adapter
      '#2768b8', // ds-allow-hardcode: Mantine palette adapter
      '#1d559c', // ds-allow-hardcode: Mantine palette adapter
      '#17457e', // ds-allow-hardcode: Mantine palette adapter
    ],
  },
});

export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {
    '--mantine-color-body': 'var(--color-surface-page)',
    '--mantine-color-text': 'var(--color-text-primary)',
    '--mantine-color-dimmed': 'var(--color-text-secondary)',
  },
  light: { '--mantine-color-placeholder': 'var(--color-text-placeholder)' },
  dark: { '--mantine-color-placeholder': 'var(--color-text-placeholder)' },
});
